import { useEffect, useState } from "react";
import api from "@/lib/api";

export const DDRAGON = "https://ddragon.leagueoflegends.com";
export const ROLES = [
  { key: "TOP", label: "Top" },
  { key: "JUNGLE", label: "Jungle" },
  { key: "MIDDLE", label: "Mid" },
  { key: "BOTTOM", label: "ADC" },
  { key: "UTILITY", label: "Support" },
];

// Stockage de l'appareil : peut être vide ou bloqué (navigation privée), le drafter doit marcher sans.
export function load(key, fallback) {
  try {
    const raw = localStorage.getItem(key);
    return raw ? JSON.parse(raw) : fallback;
  } catch {
    return fallback;
  }
}

export function save(key, value) {
  try {
    localStorage.setItem(key, JSON.stringify(value));
  } catch {
    /* stockage plein ou bloqué : la draft continue, seule la reprise est perdue */
  }
}

// Historique des drafts de cet appareil : liens en ligne (avec les tokens capitaines) et drafts locales.
const HISTORY = "drafter:history";
export const listDrafts = () => load(HISTORY, []);
export function rememberDraft(entry) {
  save(HISTORY, [entry, ...listDrafts().filter((e) => e.id !== entry.id)].slice(0, 50));
}
export const findDraft = (id) => listDrafts().find((e) => e.id === id);
export function forgetDraft(id) {
  save(HISTORY, listDrafts().filter((e) => e.id !== id));
  try {
    localStorage.removeItem(`drafter:local:${id}`);
  } catch {
    /* stockage bloqué : rien à effacer */
  }
}

// Champions et rôles gardés sur l'appareil : le mode local continue de marcher sans connexion.
// shortcut: les images restent en cache navigateur seulement, un service worker les rendrait disponibles hors ligne à coup sûr.
export function useChampions() {
  const [state, setState] = useState(() => ({ ...load("drafter:champions", { version: null, champions: [] }), error: false }));
  useEffect(() => {
    (async () => {
      const [version] = await (await fetch(`${DDRAGON}/api/versions.json`)).json();
      const { data } = await (await fetch(`${DDRAGON}/cdn/${version}/data/fr_FR/champion.json`)).json();
      const champions = Object.values(data)
        .map(({ id, name, image }) => ({ id, name, image: image.full }))
        .sort((a, b) => a.name.localeCompare(b.name, "fr"));
      save("drafter:champions", { version, champions });
      setState({ version, champions, error: false });
    })().catch(() => setState((s) => ({ ...s, error: !s.champions.length })));
  }, []);
  return state;
}

export function useRoles() {
  const [roles, setRoles] = useState(() => load("drafter:roles", {}));
  useEffect(() => {
    api.get("/drafter/roles")
      .then((r) => {
        save("drafter:roles", r.data);
        setRoles(r.data);
      })
      .catch(() => {});
  }, []);
  return roles;
}
